<template>
  <Loader :show="loading" v-if="loading"></Loader>
  <MDBRow v-else>
    <FileItemPrivate v-for="(file, i) in files" :key="i" :file="file" />
  </MDBRow>
</template>

<script setup>
import Loader from "@/components/General/Loader/index";
import { MDBRow } from "mdb-vue-ui-kit";
import FileItemPrivate from "@/components/ProductInfo/FileItemPrivate.vue";

import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { computed, onMounted } from "vue";

const store = useStore();
const route = useRoute();

const fetchPrices = async () => {
  try {
    await store.dispatch("loadSinglePriceList", route.params.slug);
  } catch (error) {
    console.log(error);
  }
};

onMounted(() => {
  fetchPrices();
});

const currentLocale = computed(() => store.getters.getCurrentLocale);
const files = computed(() => store.getters.getSinglePriceList.map(item => {
  return {
    date: item.date,
    description: item.description[currentLocale.value],
    extension: item.extension,
    file: item.file[currentLocale.value],
    id: item.id,
    title: item.title[currentLocale.value],
  }
}));
const loading = computed(() => store.getters.getPending);
</script>
